<template>
	<div>
		<div v-if="selection" class="modal-content-body-new">
			<div v-if="selection.id !== null" class="modal-content-body-new-customer" @click="removeSelection">
				<user-image :image="selection.image"></user-image>
				{{ selection.name }}
				<span aria-hidden="true" class="close icon-close-large"></span>
			</div>
			<div v-else class="modal-content-body-new-customer">
				<div class="modal-content-body-new-customer-name">
					<user-image :image="selection.image"></user-image>
					<span class="name">{{ selection.name }}</span>
				</div>
				<div class="modal-content-body-new-customer-email">
					<input-widget validate="email" :placeholder="$t('label.email')" type="email" v-model="selection.email"></input-widget>
				</div>
				<div class="modal-content-body-new-customer-phone">
					<input-widget :placeholder="$t('label.phone')" type="text" v-model="selection.phone"></input-widget>
				</div>
				<span aria-hidden="true" class="close icon-close-large" @click="removeSelection"></span>
			</div>
		</div>
		<div v-else class="modal-content-body-customers">
			<input type="text" v-model="search"
				@keydown.enter="enter"
				@keydown.down="down"
				@keydown.up="up"
				@input="searchCustomer"
				:placeholder="$t('label.customer')" />
			<ul ref="customerChooserList" :class="{ 'open': open }">
				<li v-for="(suggestion, index) in suggestions" :class="{'active': isActive(index)}"
					@click="suggestionClick(index)">
					<a href="#" :class="{ 'new': !suggestions.id }">
						<user-image :image="suggestion.image"></user-image>
						{{ suggestion.name }}
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
  import _ from 'lodash'
  import InputWidget from '@/components/widgets/InputWidget'
  import UserImage from './UserImageWidget'
  export default {
    name: 'CustomerChooserWidget',
    components: {UserImage, InputWidget},
    created () {
      document.body.addEventListener('click', this.close)
    },
    beforeDestroyed () {
      document.body.removeEventListener('click', this.close)
    },
    data () {
      return {
        search: null,
        selection: null,
        suggestions: [],
        open: false,
        current: 0
      }
    },
    methods: {
      enter () {
        this.selection = this.suggestions[this.current]
        this.open = false
        this.suggestions = []
      },
      up () {
        if (this.current > 0) {
          this.current--
        }
      },
      down () {
        if (this.current < this.suggestions.length - 1) {
          this.current++
        }
      },
      isActive (index) {
        return index === this.current
      },
      searchCustomer: _.debounce(function (e) {
        this.open = false
        if (!this.search || this.search.length < 3) {
          this.suggestions = []
          return
        }
        this.$api.get('/v1/customers?search=' + this.search).then(response => {
          let suggestions = response.data.data
          suggestions.unshift({
            id: null,
            name: this.search
          })
          this.suggestions = suggestions
          this.open = true
          this.current = 0
        }).catch(error => {
          console.error(error)
        })
      }, 300),
      suggestionClick (index) {
        this.selection = this.suggestions[index]
        this.suggestions = []
        this.$emit('input', this.selection)
        this.open = false
      },
      removeSelection () {
        this.search = null
        this.selection = null
        this.$emit('input', null)
      },
      close (event) {
        let el = this.$refs.customerChooserList
        if (el && !(el === event.target || el.contains(event.target))) {
          this.open = false
          this.search = null
          this.suggestions = []
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/widgets/CustomerChooserWidget.vue